import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { YOUTUBE_ID } from "@/lib/constants";

export default function VideoDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="video-dialog"
        className="max-w-4xl p-0 bg-[#050505] border-[#c9a14a]/30 overflow-hidden"
      >
        <DialogTitle className="sr-only">A Message from Our Brand Ambassador</DialogTitle>
        <div className="aspect-video w-full">
          {open && (
            <iframe
              data-testid="video-iframe"
              src={`https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0`}
              title="A Message from Our Brand Ambassador"
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
